export var itemMixin = {
	data: () => {
		return {
			itemQuery: {
				fabricante: '',
				grupo: '',
				marca: '',
				descricao: '',
				codigo: '',
				ncm: '',
				page: 1,
			},
			itemsList: [],
			selectedItem: {},
			selectedHeaderOptions: [
				{ text: 'CODIGO', value: 'CODIGO' },
				{ text: 'DESCRIÇÃO', value: 'DESCRICAO' },
				{ text: 'IMAGEM', value: 'imagens.image_name' },
				{ text: 'UM', value: 'UM' },
				{ text: 'MARCA', value: 'MARCA' },
				{ text: 'GRUPO', value: 'NOMEGRUPO' },
				{ text: 'PREÇO VAREJO', value: 'PRECOVAREJO' },
				{ text: 'PREÇO ATACADO', value: 'PRECOATACADO' },
				{ text: 'SALDO', value: 'SALDOITEM', align: 'center' },
			],
			itemPagination: {
				currentPage: 1,
				lastPage: 1,
				perPage: 10,
			},
		}
	},
	methods: {
		selectItem(event) {
			if (event.value) {
				this.selectedItem = event.item
			}
		},
	},
}
